<template>
    <div class="view pa24">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="一级代理商" name="dl">
          <distribution :type="1" ref="dlModel"></distribution>
        </el-tab-pane>
        <el-tab-pane label="二级分销商" name="dealer">
          <distribution :type="2" ref="dealerModel"></distribution>
        </el-tab-pane>
      </el-tabs>
    </div>
  </template>
  <script>
import distribution from "@/pages/warehouseLog/distribution.vue";
  export default {
    name: "distriHome",
    components: {
      distribution
    },
    data() {
      return {
        activeName:'dl'
      };
    },
    created() {
      // 获取所有代理商、经销商列表
    },
    methods: {
      handleClick(tab, event) {
        if ('dl'==tab){
          this.$refs.dlModel.getList()
        }else {
          this.$refs.dealerModel.getList()

        }
      }
    }
  }
  </script>

  <style lang="scss" scoped>
      .greenTag{
        color: #fff;
        background: #08A89B;
        border-radius: 6px;
        padding: 3px 5px;
        overflow: hidden;

      }
      .redTag{
        background: #e5e5e5;
        color: #f00;
        border-radius: 6px;
        padding: 3px 5px;
        overflow: hidden;
      }
  </style>

